export default __webpack_public_path__ + "static/media/dashboard.827d1cc5.svg";